import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Faz com que o container ocupe toda a altura da tela */
  padding: 10px;
  overflow-y: auto;

  @media (min-width: 768px) {
    padding: 0px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  width: 100%;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    padding: 0px 100px;
  }
`

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
  margin-top: 50px;
`

export const Description = styled.h1`
  text-align: center;
  margin-bottom: 10px;
  color: #616161;
  padding: 0 20px;
  margin-bottom: 20px;
  font-size: 2em;


  .highlight {
    color: ${theme.colors.green3};
  }

  @media (min-width: 768px) {
    padding: 0 300px;
    margin-bottom: 50px;

  }

  @media (max-width: 768px) {
    font-size: 20px;
  }

`

export const SubDescription = styled.p`
  text-align: center;
  font-size: 24px;
  color: gray;
  margin-bottom: 40px;
  padding: 0 20px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const Block1 = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 40px 20px;
  background-color: #eeeeee;
  flex-wrap: wrap;
  gap: 20px;

  @media (min-width: 768px) {
    padding: 60px 120px;
  }
`

export const Block2 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 40px 20px;
  background-color: #e0f6cc;
  flex-wrap: wrap;
  gap: 20px;

  @media (min-width: 768px) {
    padding: 60px 120px;
  }
`

export const LeftColumn = styled.div`
  flex: 1;
  padding-right: 20px;
  min-width: 200px;
`

export const RightColumn = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 200px;
`

export const Title = styled.h3`
  font-size: 26px;
  margin-bottom: 10px;

  .highlight {
    color: green;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const SubTitle = styled.p`
  font-size: 18px;
  color: gray;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`

export const LinkButton = styled(Link)`
  padding: 15px 20px;
  background-color: green;
  color: white;
  text-decoration: none;
  border-radius: 15px;
  font-weight: bold;
  transition: background-color 0.3s;
  min-width: 250px;
  text-align: center;

  &:hover {
    background-color: darkgreen;
  }

  @media (min-width: 768px) {
    min-width: 450px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
